import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';

@Component({
  selector: 'enx-shared-ui-social-login-chip',
  standalone: true,
  imports: [CommonModule, MatRippleModule],
  templateUrl: './shared-ui-social-login-chip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedUiSocialLoginChipComponent {
  label = input.required<string>();
  icon = input.required<string>();
}
